module.exports = __webpack_public_path__ + "img/chat.5a438d0c.svg";